export default "__VITE_ASSET__DwB7P_z9__"